var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticialRelocationPack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.3125,
    width: 18,
    height: 13.6876,
    rx: 4,
    fill: "#0083FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55078 10.3C7.55078 9.82743 7.9171 9.44434 8.36898 9.44434H11.6418C12.0937 9.44434 12.46 9.82743 12.46 10.3V12.0113C12.46 12.4839 12.0937 12.867 11.6418 12.867H8.36898C7.9171 12.867 7.55078 12.4839 7.55078 12.0113V10.3Z",
    fill: "#EEF6FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65163 2.98401C7.3918 2.98401 7.18116 3.20429 7.18116 3.47601V4.95203H6.24023V3.47601C6.24023 2.66083 6.87214 2 7.65163 2H12.3563C13.1358 2 13.7677 2.66083 13.7677 3.47601V4.95203H12.8267V3.47601C12.8267 3.20429 12.6161 2.98401 12.3563 2.98401H7.65163Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticialRelocationPack);
export default __webpack_public_path__ + "static/media/particialRelocationPack.51e3ddd8.svg";
export { ForwardRef as ReactComponent };